import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-day-picker/lib/style.css";
import "./index.css";
import "./modals.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
// import { createBrowserHistory } from "history";
// import configureStore from "./_reducers/configureStore";
import { store, history } from "./store";
import App from "./App";
import * as registerServiceWorker from "./registerServiceWorker";

import { onServiceWorkerUpdate } from "@3m1/service-worker-updater";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// Override default MUI fontFamily to inherit from default Bootstrap styling
const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "inherit",
    },
  },
});

window.addEventListener("beforeunload", function (e) {
  // Cancel the event
  e.preventDefault();
  console.log("Browser refresh attempted");
  // Chrome requires returnValue to be set
  e.returnValue = "";
});

// // Create browser history to use in the Redux store
// const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
// const history = createBrowserHistory({ basename: baseUrl });

// // Get the application-wide store instance, prepopulating with state from the server where available.
// const initialState = window.initialReduxState;
// const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </ThemeProvider>,
  rootElement
);

registerServiceWorker.unregister();
//registerServiceWorker.register({
//  onUpdate: onServiceWorkerUpdate,
//});
